import ApplicationSerializer from 'cio/serializers/application';
import { inject as service } from '@ember/service';

export default ApplicationSerializer.extend({
  store: service(),

  normalize(type, hash, prop) {
    // Account usages don't come with an ID, so we add one
    hash.id = 'current';

    // whenever account usage is fetched, current account is already in the store
    // (this may not be true in tests)
    // this is needed to set correct relationship, be able to access "account.usage"
    let accounts = this.store.peekAll('account');
    if (accounts.length > 0) {
      hash.account_id = accounts.firstObject.id;
    }

    return this._super(type, hash, prop);
  },
});
